<div class="timeline">
  <div class="filter-box" [formGroup]="form">
    @if (layoutService.isTabletDownView.value) {
      <div class="filter-element-sp">
        <div class="filter-text">
          <p class="label-text">検索条件</p>
          <p class="filter-result" data-cy="text-filter">{{ filterText }}</p>
        </div>
        <div class="filter-select">
          <div class="drawers">
            <a class="spen-util-link show-more-filter" (click)="changeShowFilterStatus()">
              変更<i [class]="isShowFilter ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" data-cy="show-filter-status"></i>
            </a>
          </div>
          @if (isShowFilter) {
            <p class="label-text">校種学年組</p>
            <label class="spen-mod-select">
              <select class="select" formControlName="school_year" data-cy="school-year" (change)="onSelectChange($event)">
                @for (year of schoolYears; track year) {
                  <option [value]="year">{{ year }}年度</option>
                }
              </select>
              <i class="fa fa-caret-down"></i>
            </label>
            <label class="spen-mod-select">
              <select class="select" formControlName="grade_id" data-cy="grade-id" (change)="onSelectChange($event)">
                <option class="is-placeholder" [ngValue]="null">すべての学年</option>
                @for (grade of grades; track grade.id) {
                  <option [value]="grade.id">{{ grade.school_stage_name }}{{ grade.name }}</option>
                }
              </select>
              <i class="fa fa-caret-down"></i>
            </label>
            <label class="spen-mod-select">
              <select class="select" formControlName="class_id" data-cy="class-id">
                <option class="is-placeholder" [ngValue]="null">すべての組</option>
                @for (class of classes; track class.id) {
                  <option [value]="class.id">{{ class.classroom_name }}</option>
                }
              </select>
              <i class="fa fa-caret-down"></i>
            </label>
            <div class="button-group">
              <button
                type="button"
                class="spen-mod-btn is-primary"
                data-cy="submit-filter"
                (click)="submitFilter()"
                [disabled]="isLoadingData"
              >
                適用する
              </button>
              <button
                type="button"
                class="spen-mod-btn is-default"
                data-cy="remove-filter"
                (click)="clearFilter()"
                [disabled]="isLoadingData || isDefaultForm"
              >
                選択解除
              </button>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="filter-element">
        <div class="block-filter">
          <p class="label-text">校種学年組</p>
          <label class="spen-mod-select">
            <select class="select" formControlName="school_year" data-cy="school-year" (change)="onSelectChange($event)">
              @for (year of schoolYears; track year) {
                <option [value]="year">{{ year }}年度</option>
              }
            </select>
            <i class="fa fa-caret-down"></i>
          </label>
          <label class="spen-mod-select">
            <select class="select" formControlName="grade_id" data-cy="grade-id" (change)="onSelectChange($event)">
              <option class="is-placeholder" [ngValue]="null">すべての学年</option>
              @for (grade of grades; track grade.id) {
                <option [value]="grade.id">{{ grade.school_stage_name }}{{ grade.name }}</option>
              }
            </select>
            <i class="fa fa-caret-down"></i>
          </label>
          <label class="spen-mod-select">
            <select class="select" formControlName="class_id" data-cy="class-id">
              <option class="is-placeholder" [ngValue]="null">すべての組</option>
              @for (class of classes; track class.id) {
                <option [value]="class.id">{{ class.classroom_name }}</option>
              }
            </select>
            <i class="fa fa-caret-down"></i>
          </label>
        </div>
        <div class="button-group">
          <button
            type="button"
            class="spen-mod-btn is-default"
            data-cy="remove-filter"
            (click)="clearFilter()"
            [disabled]="isLoadingData || isDefaultForm"
          >
            選択解除
          </button>
          <button type="button" class="spen-mod-btn is-primary" data-cy="submit-filter" (click)="submitFilter()" [disabled]="isLoadingData">
            検索する
          </button>
        </div>
      </div>
    }
  </div>

  @if (contentLoaded && !layoutService.isTabletDownView.value && (!isDefaulQueryParams || haveTimelineInDB)) {
    <p class="filter-text" data-cy="text-filter">検索条件：{{ filterText }}</p>
  }

  @if (contentLoaded) {
    @if (timelineDates.length > 0) {
      @for (date of timelineDates; track date; let last = $last) {
        <app-timeline-date-box
          [time]="date"
          [actions]="timelineMap[date]"
          [nextActionDate]="last ? meta.next_action_date : null"
          [actionsLoading]="actionsLoading"
          (loadMore)="loadMore()"
        >
        </app-timeline-date-box>
      }
    } @else {
      <div class="empty-block">
        @if (haveTimelineInDB || !this.isDefaulQueryParams) {
          <p class="empty-filter-result muted-text">検索結果が0件です。</p>
        } @else {
          <p class="empty-record muted-text">ここに校内のアクティビティが表示されます。</p>
          <img src="assets/images/timeline-empty.svg" alt="" class="empty-image" />
        }
      </div>
    }
  } @else {
    <div class="spen-mod-flex-loading">
      <div class="loading-icon"></div>
    </div>
  }
</div>
